






















































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import PilihanChip from "./PilihanChip.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { localISODate, parseLocalDate } from "@/utils/localDate";
import { maskTekananDarah, validasiTekananDarah } from "@/utils/tekananDarah";
import { ATURAN, AturanIsian } from "./aturanIsian";
import {
  AsesmenRah,
  ItemRisikoJatuhRah,
  KatalogRah,
  KategoriRisikoJatuhRah,
  OpsiRah,
  SesiSebelumnyaRah
} from "@/types/rekam_asuhan_hemodialisis";

@Component({
  components: { PilihanChip, VCDateTimePicker }
})
export default class AsesmenHemodialisisSection extends Vue {
  @Prop({ type: Object, required: true }) readonly asesmen!: AsesmenRah;
  @Prop({ type: Object, required: true }) readonly katalog!: KatalogRah;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ default: null }) readonly sesiSebelumnya!: SesiSebelumnyaRah | null;

  skalaNyeri = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  validasiTd = validasiTekananDarah;
  ATURAN = ATURAN;

  aturan(fn: AturanIsian): AturanIsian[] {
    return this.disabled ? [] : [fn];
  }

  get fisik() {
    return this.asesmen.fisik;
  }

  get psikososial() {
    return this.asesmen.psikososial;
  }

  get tanggalGizi(): Date | null {
    return parseLocalDate(this.asesmen.gizi.tanggal);
  }

  set tanggalGizi(value: Date | null) {
    this.asesmen.gizi.tanggal = value ? localISODate(value) : null;
  }

  get kategoriNyeri(): string {
    const skala = this.asesmen.nyeri.skala;
    if (skala === null || skala === undefined) return "";
    if (skala === 0) return "Tidak nyeri";
    if (skala <= 3) return "Ringan";
    if (skala <= 6) return "Sedang";

    return "Berat";
  }

  get warnaNyeri(): string {
    return (
      {
        "Tidak nyeri": "grey",
        Ringan: "green",
        Sedang: "orange darken-2",
        Berat: "red"
      }[this.kategoriNyeri] || "grey"
    );
  }

  get skorJatuh(): number | null {
    let total = 0;
    let terisi = false;
    this.katalog.risiko_jatuh.forEach(item => {
      const pilihan = this.asesmen.risiko_jatuh[item.key];
      const opsi = item.opsi.find(it => it.value === pilihan);
      if (opsi) {
        total += opsi.skor;
        terisi = true;
      }
    });

    return terisi ? total : null;
  }

  get kategoriJatuh(): KategoriRisikoJatuhRah | null {
    const skor = this.skorJatuh;
    if (skor === null) return null;

    return (
      this.katalog.risiko_jatuh_kategori.find(
        it => skor >= it.min && (it.max === null || skor <= it.max)
      ) || null
    );
  }

  get warnaJatuh(): string {
    return (
      { tidak: "green", rendah: "orange darken-2", tinggi: "red" }[
        this.kategoriJatuh?.kode || ""
      ] || "grey"
    );
  }

  get kategoriMis(): string {
    const skor = this.asesmen.gizi.mis_skor;
    if (skor === null || skor === undefined || String(skor) === "") return "";
    const ambang = this.katalog.mis_ambang_malnutrisi;

    return Number(skor) >= ambang
      ? `Malnutrisi (≥ ${ambang})`
      : `Tanpa malnutrisi (< ${ambang})`;
  }

  get hintSesiSebelumnya(): string {
    const sesi = this.sesiSebelumnya;
    if (!sesi || !sesi.waktu_hd) return "";
    const [tgl] = sesi.waktu_hd.split(" ");
    const [y, m, d] = tgl.split("-");
    const bb = sesi.bb_post === null ? "-" : `${sesi.bb_post} kg`;

    return `Sesi HD ${d}-${m}-${y}: BB post ${bb}`;
  }

  opsiJatuh(item: ItemRisikoJatuhRah): OpsiRah[] {
    return item.opsi.map(it => ({
      value: it.value,
      text: `${it.text} (${it.skor})`
    }));
  }

  ubahNyeri(nilai: string | null) {
    this.asesmen.nyeri.ada = nilai;
    if (nilai !== "ya") {
      this.asesmen.nyeri.skala = null;
      this.asesmen.nyeri.jenis = null;
      this.asesmen.nyeri.lokasi = null;
      this.asesmen.nyeri.durasi = null;
    }
  }

  onTdInput(val: string) {
    const bersih = maskTekananDarah(val || "", this.fisik.tekanan_darah || "");
    this.fisik.tekanan_darah = bersih;

    if (bersih !== val) {
      const field = this.$refs.tdRef as { lazyValue?: string };
      if (field) field.lazyValue = bersih;
    }
  }

  ubahAksesVaskuler(nilai: string | null) {
    this.fisik.akses_vaskuler = nilai;
    if (nilai !== "hd_kateter") this.fisik.kateter_lokasi = null;
    if (nilai !== "lainnya") this.fisik.akses_vaskuler_lain = null;
  }
}
